module.exports = __webpack_public_path__ + "img/Mask Group 2924@2x.4c87f55c.png";